/**
 * AnalysisForm Component
 *
 * Orchestrates video upload, question input, analysis options, and action buttons.
 * Mode: Deep Analysis (Mode 3)
 */
import React, { useState } from 'react';
import { VideoUploadSection } from './VideoUploadSection';
import { QuestionInput } from './QuestionInput';
import { AnalysisOptionsForm } from './AnalysisOptionsForm';
import { ActionButtons } from './ActionButtons';

export const AnalysisForm = ({
  uploadedVideo,
  setUploadedVideo,
  question,
  setQuestion,
  analysis,
  setAnalysis,
  isLoading,
  isSaving,
  handleSubmitForAnalysis,
  handleReset,
  saveAnalysis,
}) => {
  const [analysisOptions, setAnalysisOptions] = useState({
    analysisType: 'general',
    useTimestamps: true,
  });

  const handleAnalysisSubmit = () => {
    handleSubmitForAnalysis(analysisOptions);
  };

  return (
    <div className="space-y-6">
      <VideoUploadSection
        uploadedVideo={uploadedVideo}
        setUploadedVideo={setUploadedVideo}
        setAnalysis={setAnalysis}
      />

      <QuestionInput
        question={question}
        setQuestion={setQuestion}
      />

      <AnalysisOptionsForm
        options={analysisOptions}
        onOptionsChange={setAnalysisOptions}
      />

      <ActionButtons
        handleSubmitForAnalysis={handleAnalysisSubmit}
        handleReset={handleReset}
        saveAnalysis={saveAnalysis}
        isLoading={isLoading}
        isSaving={isSaving}
        uploadedVideo={uploadedVideo}
        question={question}
        analysis={analysis}
      />
    </div>
  );
};
